import { render, staticRenderFns } from "./DialogIdeaPlanNoteAddEdit.vue?vue&type=template&id=45f0cad8&scoped=true"
import script from "./DialogIdeaPlanNoteAddEdit.vue?vue&type=script&lang=js"
export * from "./DialogIdeaPlanNoteAddEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaPlanNoteAddEdit.vue?vue&type=style&index=0&id=45f0cad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f0cad8",
  null
  
)

export default component.exports